import { useState, useEffect } from 'react';

const useFetch = (range) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const apiKey = "AIzaSyBJsy3_8cK2O50D9Y7tlercG2lvUExTijI";
    const spreadsheetId = "19H8je6DcTwQNYexGBCzzN3fBC9VFKQyjTAmzagnvxA4";

    useEffect(() => {
        const fetchData = async () => {
            const url = `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values/${range}?key=${apiKey}`;
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error('Something went wrong');
                }
                const result = await response.json();
                setData(result);
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [range]);

    return { data, loading, error };
};

export default useFetch;